import React from 'react'
import { Box, Typography } from '@mui/material'
import ProfileSection from './ProfileSection'
import { useQuery } from '@tanstack/react-query';
import { CreateAccountGet } from '../../../Store/auth/createAccount';


const ProfileData = () => {

    const email = localStorage.getItem('email')
  
    const { isLoading: fieldLoading, data: questions } = useQuery({
        queryKey: 'createAccount',
        queryFn: () => CreateAccountGet(email ? email : ''),
        cacheTime: 1000 * 60 * 5,
        staleTime: 0,
    });

    

  const documents = questions?.documents || {};

  const hardcodedObjects = [
    { label: 'To verify credentials of NPOs/NGOs', name: 'to_verify_npo' },
    { label: 'To search for NPO/NGO products', name: 'to_search_npo' },
    { label: 'To find NPOs/NGOs', name: 'to_find_npo' },
    { label: 'To volunteer', name: 'to_volunteer' },
    { label: 'To donate', name: 'to_donate' },
    { label: 'To learn about the NPO/NGO sector', name: 'to_learn' },
    { label: 'To give in-kind', name: 'to_give_in_kind' },
    { label: 'For research', name: 'for_research' },
  ];
  const hardcodedObjects2 = [
      { label: 'NPO Sector Professional', name: 'npo_sector_professional' },
      { label: 'CSR Professional', name: 'csr_professional' },
      { label: 'Government Employee', name: 'government_employee' },
      { label: 'Corporate Employee', name: 'corporate_employee' },
      { label: 'Student', name: 'student' },
      { label: 'Academia', name: 'academia' },
      { label: 'Media person', name: 'media_person' },
      { label: 'Impact assessor', name: 'impact_assessor' },
      { label: 'Financial auditor', name: 'financial_auditor' },
      { label: 'Consultant to NPO', name: 'consultant_to_npo' },
      { label: 'Advisor to donors', name: 'advisor_to_donors' },
      { label: 'Participant in events for a cause', name: 'participant_in_events_for_a_cause' },
      { label: 'Fundraiser', name: 'fundraiser' },
      { label: 'Philanthropist', name: 'philanthropist' },
      { label: 'Participant in events for a cause', name: 'participant_in_events_for_a_cause' },
  ];
  
  const labelsToDisplay = hardcodedObjects
    .filter(item => documents[item.name] === 1) // Match name in the API data
    .map(item => item.label); 
    
  const labelsToDisplay2 = hardcodedObjects2
    .filter(item => documents[item.name] === 1) // Match name in the API data
    .map(item => item.label); 
  
  return (
    <>
        <Box sx={{height:'', padding:'10px 170px 0 70px' , color:'black' , position:'relative' , zIndex:40}}>
            <ProfileSection user  
                UsAccountType="Lorus ipsum" 
                UsEmailId={documents?.email_id}  
                UsName={documents?.full_name}  
                UsMobileNumber={documents?.mobile_number}
                UsLocation={documents?.location}
            />
            <ProfileSection 
                purpose
                labelsToDisplay={labelsToDisplay}
                fieldLoading
            />
            <ProfileSection 
                interest
                InThematic={documents?.thematic_area}
                InGeography={documents?.geography_state}
                InBenificiary={documents.beneficiary_groups}
                InFCRA={documents.fcra}
            />
            <ProfileSection 
                updates
                uptrue={documents.periodic_insights === 1 ? true :false}
                Uptags={documents.tags}
            />
            <ProfileSection 
                type
                tyUser={documents.type_of_user}
                labelsToDisplay2={labelsToDisplay2}
                tyList={["NPO Sector Professional" , "Government Employee"]}
                tyName={documents.name_of_institution}
                organisation={documents.select_here}
            />
            
        </Box>
    </>
  )
}

export default ProfileData